<template>
  <div class="w-screen h-screen grid grid-cols-nav-content overflow-hidden">
    <main-nav-bar />
    <slot />
  </div>
</template>

<script setup lang="ts">
import MainNavBar from '@/shared/components/MainNavBar.vue'
</script>
